<template>
    <defaultSec class="work-order-list">
        <template #title>
            <div  class="default-header" style="display: flex;justify-content: space-between">
                <h3>工单管理</h3>
                <div>
                        <el-button style="float: right; padding: 5px 10px" type="danger" @click="toInstructions" icon="el-icon-s-claim">工单管理指导手册</el-button>
                </div>

            </div>

        </template>
        <el-radio-group
            v-model="formParam.viewScope"
            size="small"
            class="work-order-view-scope"
            @change="changeViewScope">
            <el-radio-button label="ALL">全部工单</el-radio-button>
            <el-radio-button label="MY_CREATED">我创建的</el-radio-button>
            <el-radio-button label="MY_PENDING">待我处理</el-radio-button>
            <el-radio-button label="MY_PROCESSED">我处理过的</el-radio-button>
        </el-radio-group>
        <el-form :inline="true" :model="formParam" class="demo-form-inline select-wrap work-order-filter" size="mini">
            <el-form-item label="综合单号">
                <el-input
                    v-model="formParam.someID"
                    class="combined-id-input"
                    placeholder="工单/订单/售后/线下单号或用户ID"
                    clearable
                    @keyup.enter.native="handleSearch">
                </el-input>
            </el-form-item>
            <el-form-item label="工单状态">
                <el-select size="small" clearable v-model="formParam.workOrderStatus" placeholder="请选择">
                    <el-option
                        v-for="item in statusList"
                        :key="item.key"
                        :label="item.name"
                        :value="item.key">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="售后问题">
              <el-cascader
                  size="small"
                  clearable
                  v-model="formParam.issueCode"
                  :options="issueOptions"
                  :props="{ emitPath: false }"
                  placeholder="请选择">
              </el-cascader>
            </el-form-item>
            <el-form-item label="创建时间">
                <el-date-picker
                    clearable
                    v-model="formParam.createTimeStr"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
            <div id="work-order-advanced-filters" v-show="advancedFiltersVisible" class="advanced-filter-row">
                <el-form-item label="购买渠道">
                    <el-radio-group size="mini" v-model="formParam.orderOnline">
                        <el-radio-button :label="null">全部</el-radio-button>
                        <el-radio-button :label="1">线上</el-radio-button>
                        <el-radio-button :label="2">线下</el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="创建人">
                    <el-select filterable v-model="formParam.createUserId" placeholder="请选择" clearable>
                    <el-option
                        v-for="item in userList"
                        :key="item.USER_ID"
                        :label="userDisplayName(item)"
                        :value="item.USER_ID">
                    </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="通知处理人">
                    <el-select filterable v-model="formParam.handleUserId" placeholder="请选择" clearable>
                    <el-option
                        v-for="item in userList"
                        :key="item.USER_ID"
                        :label="userDisplayName(item)"
                        :value="item.USER_ID">
                    </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="责任部门">
                    <el-select filterable clearable v-model="formParam.responsibleDeptDingdingId" placeholder="请选择">
                    <el-option
                        v-for="item in deptList"
                        :key="item.key"
                        :label="item.name"
                        :value="item.key">
                    </el-option>
                    </el-select>
                </el-form-item>
            </div>
            <el-form-item class="filter-actions">
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
                <el-button icon="el-icon-refresh-left" @click="resetFilters">重置</el-button>
                <el-button
                    type="text"
                    class="advanced-filter-toggle"
                    aria-controls="work-order-advanced-filters"
                    :aria-expanded="String(advancedFiltersVisible)"
                    @click="advancedFiltersVisible = !advancedFiltersVisible">
                    {{advancedFiltersVisible ? '收起筛选' : '更多筛选'}}
                    <i :class="advancedFiltersVisible ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
                </el-button>
                <el-button type="warning" @click="toDetail(0)">新建工单</el-button>
            </el-form-item>
        </el-form>
        <tablePagination :total="total" :pageSize="formParam.pageSize" :currentPage="formParam.pageNum" @handlePage="handlePage">
            <el-table v-loading="loading" :data="tableList" row-key="workOrderNo" border size="mini" class="work-order-table">
                <el-table-column prop="workOrderNo" label="工单编号" fixed="left" width="190">
                  <template slot-scope="scope">
                    <el-link type="primary" :underline="false" class="work-order-no" @click="toDetail(scope.row.workOrderNo)">
                        {{scope.row.workOrderNo}}
                    </el-link>
                    <div class="cell-meta-row">
                        <span><i :class="scope.row.orderOnline==='线上'?'el-icon-goods':'el-icon-s-shop'"></i> {{scope.row.orderOnline || '-'}}</span>
                        <el-tag size="mini" :type="temperatureZoneTagType(scope.row.temperatureZone)">
                            {{temperatureZoneText(scope.row.temperatureZone)}}
                        </el-tag>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="workOrderTypeName" label="问题与沟通" min-width="250">
                    <template slot-scope="scope">
                        <div class="label-text"><b>问题大类：</b><span>{{scope.row.workOrderTypeGroup || '-'}}</span></div>
                        <div class="label-text"><b>具体问题：</b><span>{{scope.row.workOrderTypeName || '-'}}</span></div>
                        <div class="label-text" v-if="scope.row.workOrderTypeGroup === '质量'">
                            <b>产品线：</b><span>{{scope.row.workOrderTypeMatClass || '-'}}</span>
                        </div>
                        <div class="label-text" v-if="scope.row.workOrderTypeGroup === '质量'">
                            <b>工厂：</b><span>{{scope.row.workOrderTypeFactory || '-'}}</span>
                        </div>
                        <div class="label-text" v-if="scope.row.workOrderTypeGroup === '运营'">
                            <b>店铺：</b><span>{{scope.row.onlineShopName || scope.row.workOrderTypePlatform || '-'}}</span>
                        </div>
                        <div class="label-text"><b>问题描述：</b><span class="cell-clamp-2" :title="scope.row.workOrderDesc">{{scope.row.workOrderDesc || '-'}}</span></div>
                        <div class="cell-tag-row">
                            <el-tag size="mini" :type="communicationStatusTagType(scope.row.communicationStatus)">
                                {{communicationStatusText(scope.row.communicationStatus)}}
                            </el-tag>
                        </div>
                        <div v-if="scope.row.productionQuestion" class="status-detail cell-clamp-2" :title="scope.row.productionQuestion">
                            <b>待回复：</b>{{scope.row.productionQuestion}}
                        </div>
                        <div v-else-if="scope.row.communicationResult" class="status-detail cell-clamp-2" :title="scope.row.communicationResult">
                            <b>沟通结果：</b>{{scope.row.communicationResult}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="orderNo" label="关联订单与商品" min-width="230">
                    <template slot-scope="scope">
                        <div class="label-text" v-if="scope.row.orderNo"><b>订单编号：</b><span>{{scope.row.orderNo}}</span></div>
                        <div class="label-text" v-if="scope.row.refundNo"><b>售后单号：</b><span>{{scope.row.refundNo}}</span></div>
                        <div class="label-text" v-if="scope.row.offlineOrderNo"><b>线下单号：</b><span>{{scope.row.offlineOrderNo}}</span></div>
                        <div class="label-text" v-if="scope.row.productList && scope.row.productList.length">
                            <b>售后商品：</b>
                            <span class="cell-clamp-2" :title="productSummary(scope.row.productList)">
                                {{productSummary(scope.row.productList)}}
                            </span>
                        </div>
                        <div v-if="!scope.row.orderNo && !scope.row.refundNo && !scope.row.offlineOrderNo && (!scope.row.productList || !scope.row.productList.length)" class="empty-cell">暂无关联信息</div>
                    </template>
                </el-table-column>
                <el-table-column label="状态与当前流程" min-width="190">
                    <template slot-scope="scope">
                        <div class="cell-tag-row">
                            <el-tag size="mini" :type="workOrderStatusTagType(scope.row.workOrderStatus)">{{scope.row.workOrderStatusName || '-'}}</el-tag>
                            <el-tag size="mini" :type="workflowStageTagType(scope.row.currentStage)">
                            {{workflowStageText(scope.row.currentStage)}}
                            </el-tag>
                        </div>
                        <div class="status-detail">
                            <b>当前处理人：</b><span class="current-assignee">{{currentAssigneeText(scope.row)}}</span>
                        </div>
                        <div v-if="scope.row.resultSummary" class="status-detail">
                            <b>结果：</b>{{handleModeText(scope.row.resultSummary)}}
                        </div>
                        <div class="status-detail notification-status">
                            <b>通知：</b>
                            <el-tag size="mini" :type="notificationStatusTagType(scope.row.notificationStatus)">
                                {{notificationStatusText(scope.row.notificationStatus)}}
                            </el-tag>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="workOrderResult" label="处理结果" min-width="210">
                    <template slot-scope="scope">
                        <div class="label-text"><b>通知处理人：</b><span>{{scope.row.handleUserId}}</span></div>
                        <div class="label-text" v-if="scope.row.responsibleDeptDingdingId"><b>责任部门：</b>
                            <span class="response-dept">
                                <el-dropdown size="small" split-button type="success" @command="(key)=>handleCommand(key,scope.row)">
                                     {{scope.row.responsibleDeptDingdingId}}
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item
                                            v-for="item in deptList"
                                            :key="item.key"
                                            :command="item.key">
                                            {{item.name}}
                                        </el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </span>
                        </div>
                        <div class="label-text" v-if="scope.row.workOrderResult"><b>处理结果：</b><span>{{scope.row.workOrderResult}}</span></div>
                        <div class="label-text" v-if="scope.row.workOrderResultDesc"><b>结果描述：</b><span class="cell-clamp-2" :title="scope.row.workOrderResultDesc">{{scope.row.workOrderResultDesc}}</span></div>
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" label="创建信息" width="160">
                    <template slot-scope="scope">
                        <div>{{scope.row.createUserId || '-'}}</div>
                        <div class="create-time">{{scope.row.createTime || '-'}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right" width="160">
                    <template slot-scope="scope">
                        <el-button style="margin-right: 8px" type="danger" plain size="mini" @click="toDetail(scope.row.workOrderNo)">{{primaryActionText(scope.row)}}</el-button>
                        <el-popconfirm
                            v-if="hasAction(scope.row,'VOID_DRAFT')"
                            title="确定要作废这条工单吗？"
                            @confirm="delWorkOrder(scope.row.workOrderNo)"
                        >
                            <el-button slot="reference" type="warning" plain size="mini">作废</el-button>

                        </el-popconfirm>
                    </template>
                </el-table-column>
                <template slot="empty">
                    <div class="table-empty">未找到匹配工单，请调整筛选条件</div>
                </template>
            </el-table>
        </tablePagination>
    </defaultSec>
</template>

<script>
import defaultSec from '@c/defaultSection'
import tablePagination from '@c/tablePagination'

const FILTER_QUERY_KEYS = [
    'viewScope',
    'orderOnline',
    'issueCode',
    'someID',
    'workOrderStatus',
    'createUserId',
    'handleUserId',
    'responsibleDeptDingdingId',
    'dingDeptId',
    'createTimeStart',
    'createTimeEnd'
]

function getQueryValue(value) {
    const normalizedValue = Array.isArray(value) ? value[0] : value
    return normalizedValue === undefined || normalizedValue === null || normalizedValue === ''
        ? null
        : normalizedValue
}

function getNumberQueryValue(value) {
    const normalizedValue = getQueryValue(value)
    if (normalizedValue === null) {
        return null
    }
    const numberValue = Number(normalizedValue)
    return Number.isNaN(numberValue) ? null : numberValue
}

export default {
    name: "workOrderList",/*此处的name必须有且与include中的一致*/
    data() {
        const query = this.$route.query || {}
        const createTimeStart = getQueryValue(query.createTimeStart)
        const createTimeEnd = getQueryValue(query.createTimeEnd)
        return {
            formParam:{
                pageSize:10,
                pageNum:Number(this.$route.params.pageNum)||1,
                viewScope:getQueryValue(query.viewScope) || 'ALL',
                orderOnline:getNumberQueryValue(query.orderOnline),
                issueCode:getQueryValue(query.issueCode),
                someID:getQueryValue(query.someID),
                workOrderStatus:getNumberQueryValue(query.workOrderStatus),
                createUserId:getQueryValue(query.createUserId),
                handleUserId:getQueryValue(query.handleUserId),
                responsibleDeptDingdingId:getQueryValue(query.responsibleDeptDingdingId) || getQueryValue(query.dingDeptId),
                createTimeStr:createTimeStart && createTimeEnd ? [createTimeStart, createTimeEnd] : null,
            },
            tableList:[],
            userList:[],
            deptList:[],
            issueOptions:[],
            statusList:[],
            total:0,
            loading:true,
            advancedFiltersVisible:Boolean(
                getQueryValue(query.orderOnline) ||
                getQueryValue(query.createUserId) ||
                getQueryValue(query.handleUserId) ||
                getQueryValue(query.responsibleDeptDingdingId) ||
                getQueryValue(query.dingDeptId)
            )
        }
    },
    components:{
        defaultSec,tablePagination
    },
    mounted(){
        this.initIssueOptions()
        this.initUserList()
        this.initStatusList()
        this.initDeptList()
        this.initList()
    },
    activated(){
    },
    methods: {
        changeViewScope(){
            this.formParam.pageNum = 1
            this.initList()
        },
        handleSearch(){
            this.formParam.pageNum = 1
            this.initList()
        },
        resetFilters(){
            const pageSize = this.formParam.pageSize
            const viewScope = this.formParam.viewScope
            this.formParam = {
                pageSize,
                pageNum:1,
                viewScope,
                orderOnline:null,
                issueCode:null,
                someID:null,
                workOrderStatus:null,
                createUserId:null,
                handleUserId:null,
                responsibleDeptDingdingId:null,
                createTimeStr:null
            }
            this.advancedFiltersVisible = false
            this.initList()
        },
        hasAction(row,action){
            return Array.isArray(row && row.availableActions) && row.availableActions.indexOf(action) > -1
        },
        primaryActionText(row){
            if(this.hasAction(row,'EDIT_DRAFT')) return '编辑草稿'
            if(this.hasAction(row,'HANDLE_COMPLAINT')) return '处理升级'
            if(this.hasAction(row,'HANDLE_PAYMENT')) return '处理赔付'
            if(this.hasAction(row,'CONFIRM_RESPONSIBILITY')) return '确认责任'
            if(this.hasAction(row,'SUBMIT_RESULT')) return '提交结果'
            return '查看'
        },
        workflowStageText(stage){
            return {
                INITIAL_SUBMISSION:'提交工单',
                DEPT_HANDLE:'历史处理节点',
                COMPLAINT_HANDLE:'升级处理',
                PAYMENT:'赔付处理',
                PRELIMINARY_RESPONSIBILITY:'初步责任',
                FINAL_RESPONSIBILITY:'责任确认'
            }[stage] || (Number(stage) === 10 ? '已关闭' : (stage || '暂无'))
        },
        workflowStageTagType(stage){
            return stage === 'FINAL_RESPONSIBILITY' ? 'danger' : (stage === 'PAYMENT' ? 'warning' : (stage ? '' : 'info'))
        },
        workOrderStatusTagType(status){
            return {0:'info',1:'warning',2:'danger',3:'warning',10:'success'}[Number(status)] || 'info'
        },
        currentAssigneeText(row){
            const assignee = row && row.currentAssignee
            return assignee && (assignee.userName || assignee.userId) || '-'
        },
        handleModeText(mode){
            return {REISSUE:'补发',REFUND:'退款',REISSUE_AND_REFUND:'补发+退款',COMPENSATION:'赔付',UPGRADE:'升级'}[mode] || mode || '-'
        },
        productSummary(productList){
            if(!Array.isArray(productList) || !productList.length) return '-'
            const firstProduct = productList[0] || {}
            const firstText = `${firstProduct.productName || '-'}${firstProduct.productPici ? `（${firstProduct.productPici}）` : ''}`
            return productList.length > 1 ? `${firstText} 等${productList.length}件` : firstText
        },
        userDisplayName(user){
            return user ? (user.USER_NAME || user.USER_NICK || user.USER_ID) : '-'
        },
        temperatureZoneText(value){
            return {COLD:'低温',AMBIENT:'常温',UNKNOWN:'待确认'}[value] || '待确认'
        },
        temperatureZoneTagType(value){
            return {COLD:'',AMBIENT:'success',UNKNOWN:'warning'}[value] || 'warning'
        },
        communicationStatusText(value){
            return {
                PENDING_REPLY:'待生产回复',
                REPLIED:'生产已回复',
                RESULT_AVAILABLE:'已有沟通结果',
                NO_REPLY_REQUIRED:'无需生产回复',
            }[value] || '未设置'
        },
        communicationStatusTagType(value){
            return {
                PENDING_REPLY:'warning',
                REPLIED:'success',
                RESULT_AVAILABLE:'',
                NO_REPLY_REQUIRED:'info',
            }[value] || 'info'
        },
        notificationStatusText(value){
            return {
                NONE:'无通知',
                PENDING:'待发送',
                SUCCESS:'发送成功',
                FAILED:'发送失败',
            }[value] || '无通知'
        },
        notificationStatusTagType(value){
            return {
                NONE:'info',
                PENDING:'warning',
                SUCCESS:'success',
                FAILED:'danger',
            }[value] || 'info'
        },
        getFilterRouteQuery() {
            const query = {...this.$route.query}
            FILTER_QUERY_KEYS.forEach(key => {
                delete query[key]
            })
            const filterKeys = [
                'viewScope',
                'orderOnline',
                'issueCode',
                'someID',
                'workOrderStatus',
                'createUserId',
                'handleUserId',
                'responsibleDeptDingdingId'
            ]
            filterKeys.forEach(key => {
                const value = this.formParam[key]
                if (value !== undefined && value !== null && value !== '') {
                    query[key] = value
                }
            })
            if (this.formParam.createTimeStr && this.formParam.createTimeStr.length === 2) {
                query.createTimeStart = this.formParam.createTimeStr[0]
                query.createTimeEnd = this.formParam.createTimeStr[1]
            }
            return query
        },
        handleRouterError(error) {
            if (!error || error.name !== 'NavigationDuplicated') {
                this.$message({
                    message: '工单列表状态保存失败，请重试',
                    type: 'error'
                })
            }
        },
        syncFilterRouteQuery() {
            return this.$router.replace({
                query: this.getFilterRouteQuery()
            }).catch(error => this.handleRouterError(error))
        },
        initList(syncRouteQuery = true) {
            if (syncRouteQuery) {
                this.syncFilterRouteQuery()
            }
            this.loading = true
            let param = {...this.formParam};
            param.createTimeStr = param.createTimeStr?param.createTimeStr.join(','):null;
            this.$apiGet('lechun-csms/workOrder/workOrderList',param).then(res => {
                this.loading = false
                this.total = res.total;
                this.tableList = res.list

            })
        },
        initUserList() {
            this.$apiGet('lechun-baseservice/user/getUserListForDorpbox',{}).then(res => {
                this.userList = res || []

            })
        },
        initDeptList() {
            this.$apiGet('lechun-csms/workOrder/getWorkOrderResponseDept',{}).then(res => {
                this.deptList = res

            })
        },
        initStatusList() {
            this.$apiGet('lechun-csms/workOrder/workOrderStatusSimple',{}).then(res => {
                this.statusList = res

            })
        },
        initIssueOptions() {
            this.$apiGet('lechun-csms/workOrder/classification/issues',{includeDisabled:true}).then(res => {
                this.issueOptions = res || []
            })
        },
        delWorkOrder(id) {
            this.$apiGet('lechun-csms/workOrder/deleteWorkOrder',{ workOrderNo:id}).then(() => {
                this.$message({
                    message: '工单已作废',
                    type: 'success'
                })
                this.initList()

            })
        },
        handlePage(page){
            this.formParam.pageNum = page;
            this.$router.push({
                name: 'workOrderList',
                params: {pageNum: page},
                query: this.getFilterRouteQuery()
            }).catch(error => this.handleRouterError(error))
            this.initList(false)

        },
        toDetail(id){
            this.syncFilterRouteQuery().then(() => {
                this.$router.push({
                    name: 'workOrderDetail',
                    params: {id: id}
                }).catch(error => this.handleRouterError(error))
            })
        },
        toInstructions(){
            window.open('https://alidocs.dingtalk.com/i/nodes/ydxXB52LJq7YOprLFqxjLnBGWqjMp697?cid=4448346107&corpId=ding5473140ac462716435c2f4657eb6378f&doc_type=wiki_doc&iframeQuery=utm_medium=im_card&utm_source=im&utm_medium=im_card&utm_scene=person_space&utm_source=im','_blank')
        },
        handleCommand(key,item){
            this.$apiGet('lechun-csms/workOrder/saveRespDept',{  dingDeptId:key,workOrderNo:item.workOrderNo}).then(() => {
                this.$message({
                    message: '责任部门已修改成功',
                    type: 'success'
                })
                this.initList()

            })
        }
    }
}
</script>


<style lang="scss">
.work-order-list{
    .work-order-view-scope{
        margin: 0 0 16px;
    }
    .work-order-filter{
        padding: 14px 16px 2px;
        margin-bottom: 14px;
        background: #f7f9fc;
        border: 1px solid #ebeef5;
        border-radius: 4px;
        .el-form-item{
            margin-right: 18px;
            margin-bottom: 12px;
        }
        .el-select,
        .el-cascader{
            width: 180px;
        }
        .combined-id-input{
            width: 280px;
        }
        .advanced-filter-row{
            display: inline;
        }
        .filter-actions{
            white-space: nowrap;
        }
        .advanced-filter-toggle{
            padding-left: 4px;
            padding-right: 4px;
        }
    }
    .work-order-table{
        .work-order-no{
            font-weight: 600;
        }
        .cell-meta-row{
            display: flex;
            align-items: center;
            gap: 8px;
            margin-top: 8px;
            color: #606266;
        }
        .cell-tag-row{
            display: flex;
            flex-wrap: wrap;
            gap: 6px;
            margin-top: 7px;
        }
        .current-assignee{
            color: #303133;
            font-weight: 600;
        }
        .notification-status{
            display: flex;
            align-items: center;
            gap: 4px;
        }
        .create-time{
            margin-top: 6px;
            color: #909399;
            line-height: 18px;
        }
        .empty-cell,
        .table-empty{
            color: #909399;
        }
    }
    .label-text{
        display: flex;
        margin-bottom: 5px;
        b{
            width: 60px;
            display: block;
            text-align: right;
            font-weight: normal;
        }
        >span{
            flex: 1;
            font-weight: bolder;
        }
    }
    .cell-clamp-2{
        display: -webkit-box;
        overflow: hidden;
        line-height: 18px;
        white-space: pre-line;
        word-break: break-all;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
    }
    .copy-text {
        display: block;
        white-space: pre-line;
        margin: 0;
        line-height: 18px;
        background: #f2f2f2;
        border: 1px solid #e8e8e8;
        border-radius: 5px;
        padding: 6px;
        max-height: 127px;
        overflow-y: scroll;
    }
    .status-detail {
        margin-top: 6px;
        color: #606266;
        line-height: 18px;
        white-space: pre-line;
        word-break: break-all;
    }
    @media (max-width: 1366px){
        .work-order-filter{
            .combined-id-input{
                width: 230px;
            }
            .el-date-editor--daterange{
                width: 250px;
            }
        }
    }
}

.response-dept{
    .el-button--small{
        padding: 4px 10px;
    }
}
</style>
